import { useMutation } from '@apollo/client';
import { FormControl, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import {
  createWorkOrder as createWorkOrderMutation,
  MIXPANEL_EVENTS,
} from 'vendor-marketplace-shared-library';
import useMixpanel from '../../hooks/useMixpanel';
import useAlert from '../../hooks/useAlert';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loader from '../../components/common/Loader';
import PrimaryButton from '../../components/common/styled-mui-overrides/PrimaryButton';

export default function CreateWorkOrderPage() {
  const { setAlert } = useAlert();
  const { mixpanelTrack } = useMixpanel();
  const navigate = useNavigate();
  const [searchParams, _] = useSearchParams();
  const [description, setDescription] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [createWorkOrder] = useMutation(createWorkOrderMutation, {
    onCompleted: data => {
      mixpanelTrack(MIXPANEL_EVENTS.WORK_ORDER_CREATE_COMPLETED, {
        workOrderId: data.createWorkOrder.id,
      });
      setDescription('');
      navigate(`/create-work-order/${data.createWorkOrder.id}?step=1`);
      setIsLoading(false);
    },
    onError: () => {
      setAlert({
        message: 'Something went wrong. Please try again.',
      });
      setIsLoading(false);
    },
  });

  const vendorId = searchParams.get('workOrderVendorId');
  const propertyId = searchParams.get('propertyId');

  const onCreate = async () => {
    setIsLoading(true);
    mixpanelTrack(MIXPANEL_EVENTS.WORK_ORDER_CREATE_ATTEMPTED);
    await createWorkOrder({
      variables: {
        input: {
          description,
          procureVendorId: vendorId ?? null,
          propertyId: Number(propertyId) ?? null,
          userCoordinates: {
            latitude: 0,
            longitude: 0,
          },
        },
      },
    });
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Grid container sx={styles.mainContainer}>
      <Grid item container direction='column' sx={styles.subContainer}>
        <Grid item container xs={12} rowGap={4} sx={styles.itemContainer}>
          <Grid item xs={12}>
            <Typography textAlign='center'>
              {"Describe the issue, we'll help you create a quality work order."}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                variant='outlined'
                value={description}
                multiline
                rows={4}
                placeholder={'The AC is making a funny noise...'}
                onChange={e => {
                  setDescription(e.target.value);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={8}>
            <PrimaryButton onClick={onCreate} fullWidth>
              Create
            </PrimaryButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  mainContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 10,
  },
  subContainer: {
    maxWidth: '600px',
    minWidth: '320px',
  },
  itemContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
};
